<template>
    <div class="category-box" id="category">
        <!-- <div class="search" v-if="$store.state.userAgent === 'Mobile'"> -->
        <div class="search">
          <div class="fake-input" @click="goSearch">搜索你要找的产品</div>
          <img src="../../assets/images/search.png" alt="" width="17" height="17" class="searchImg">
        </div>
        <div class="first-category-row">
          <div class="first-category">
            <div v-for="(list) in firstCategoryLabelList" :key="list.id" @click="changeFirstCategoryLabel(list.id)">
              <div class="first-category-item" v-show="list.mini_img_url">
                <img :class="[list.isSelected ? 'img-active' : 'img']" :src="list.mini_img_url" alt="" width="45px" height="45px">
                <div :class="[list.isSelected ? 'label-active' : 'label']">{{ list.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <side-bar class="sidebar" :labelList="labelList" @changeLabel="changeLabel"/>
          <category-card class="category-card" :goodList="goodList" @addToCart="addToCart" @cardClick="goShopDescPage" v-show="!loading"/>
        </div>
    </div>
</template>

<script>
import CategoryCard from '../../components/card/CategoryCard.vue'
import SideBar from '../../components/sidebar/index.vue'
const seo = require('../../../config/index')
import { queryAllFirstCategoryByShopId, queryAllSecondCategoryById, querOnSaleCategoryGoodsByUid, queryCartGoodsTotalAmount, createCart,
 wxSdk, getIP, queryIPLocation, createUserStas } from '@/api/api'
import { Toast } from 'vant'
import wx from "weixin-js-sdk";
import { getopenIdByCode, isWeiXin, getBaseInfos } from '@/utils/index';

export default {
  name: 'Category',
  components: {
    SideBar,
    CategoryCard,
  },
  created(){
    this.getData()
    this.handleIp()
    // this.initOpenId()
  },
  activated(){
    document.title = seo.config.seoPage.categoryPage.title
    history.pushState(null, null, document.URL); 
    window.addEventListener("popstate", this.myBack, false);
    this.wxShare()
    this.firstCategoryId = sessionStorage.getItem('firstCategoryId')
  },
  deactivated(){
    window.removeEventListener("popstate", this.myBack, false);
  },
  watch:{
    firstCategoryId () {
      this.getData()
    }
  },
  data:()=>{
    return {
      goodList:[],
      labelList:[],
      cartAmount: 0,
      firstCategoryLabelList:[],
      appName: seo.config.appName,
      shopName: seo.config.shopName,
      loading: false,
      selectFirstCategoryId: '',
      firstCategoryId: sessionStorage.getItem('firstCategoryId'),
      isLogin: localStorage.getItem('token') ? true : false,
    //   userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo'))[0] : {},
    }
  },
  methods:{
    getData(){
      this.loading = true
      // 优化效果
      this.labelList = [{
          category_id: '-1',
          id: '-1',
          label: '',
          isSelected: false
      }]
      queryAllFirstCategoryByShopId({ shopId: seo.config.shopId }).then((res)=>{
        let resData = res.data.data.data
        this.firstCategoryLabelList = []
        resData.forEach((item, index) => {
          let temp = {}
          temp.id = item.first_category_id
          temp.name = item.first_category_name
          temp.img_url = item.img_url
          temp.mini_img_url = item.mini_img_url
          if(this.firstCategoryId){
            if(this.firstCategoryId === temp.id){
              temp.isSelected = true
            } else {
              temp.isSelected = false
            }
          } else {
            if(index === 0){
              temp.isSelected = true
            } else {
              temp.isSelected = false
            }
          }
          this.firstCategoryLabelList.push(temp)
        })
        let tempfirstCategoryId = this.firstCategoryId ? this.firstCategoryId : resData[0].first_category_id
        this.selectFirstCategoryId = tempfirstCategoryId
        this.getSecondCategory(tempfirstCategoryId)
      })
    },
    getSecondCategory(id){
      queryAllSecondCategoryById({ shopId: seo.config.shopId, firstCategoryId: id }).then((res)=>{
        let resData = res.data.data.data
        this.labelList = []
        resData.forEach((item, index)=>{
          let temp = {}
          temp.category_id = item.category_id
          temp.id = item.second_category_id
          temp.label = item.second_category_name
          if(index === 0){
            temp.isSelected = true
          } else {
            temp.isSelected = false
          }
          this.labelList.push(temp)
        })
        this.getCategoryGoods(id + '-' + this.labelList[0].id)
      })
    },
    goShopDescPage(id){
      this.$router.push({ path:'/shop-desc', query:{ gid: id } })
    },
    getCategoryGoods(id){
      this.loading = true
      querOnSaleCategoryGoodsByUid({ uid: '1000001', categoryId: id}).then((res)=>{
          let resData = res.data.data.data
          this.goodList = []
          resData.forEach(item=>{
            let temp = {}
            temp.id = item.gid
            temp.img = item.mini_main_list_img_url
            temp.title = item.title
            temp.price = item.price
            temp.amount = item.amount
            temp.type = (item.color && item.type) ? (item.color + ' | ' + item.type) : '默认'
            temp.category = item.category
            this.goodList.push(temp)
          })
          this.loading = false
        })
    },
    goSearch(){
      sessionStorage.setItem('fromPath','category')
      this.$router.push({ path:'/search', query:{ type:'goods' } })
    },
    addToCart(list){
      if(this.isLogin){
        let goodInfo = {}
        goodInfo.gid = list.id
        goodInfo.imgUrl = list.img
        goodInfo.title = list.title
        goodInfo.type = list.type
        goodInfo.amount = 1
        goodInfo.price = list.price
        goodInfo.uid = Number(JSON.parse(localStorage.getItem('userInfo'))[0].uid)
        goodInfo.shop = this.shopName
        createCart({ goodInfo: goodInfo }).then(()=>{
          this.initCartGoodsAmount()
          Toast('加入购物车成功')
        })
      } else {
        sessionStorage.setItem('fromPath', '/category')
        this.$router.push({ name:'Login', params:{ text:'选商品' } })
      }
    },
    changeFirstCategoryLabel(id){
      this.getSecondCategory(id)
      this.selectFirstCategoryId = id
      this.firstCategoryLabelList.forEach(label => {
        if (label.id === id) {
          label.isSelected = true;
        } else {
          label.isSelected = false;
        }
      });
    },
    changeLabel(id){
      this.getCategoryGoods(this.selectFirstCategoryId + '-' +id)
      this.labelList.forEach(label => {
        if (label.id === id) {
          label.isSelected = true;
        } else {
          label.isSelected = false;
        }
      });
    },
    initCartGoodsAmount(){
      if(this.isLogin){
          let uid = localStorage.getItem('userInfo') ? String(JSON.parse(localStorage.getItem('userInfo'))[0].uid) : ''
          queryCartGoodsTotalAmount({ uid: uid }).then((res)=>{
            this.$store.commit('Set_CartAmount_State', res.data.total_amount)
          })
      } else {
        this.$store.commit('Set_CartAmount_State', 0)
      }
    },
    myBack() {
      history.pushState(null, null, document.URL);
    },
    handleIp(){
      getIP({}).then((res)=>{
        queryIPLocation({ ip: res.data.data }).then((result)=>{
          let resData = result.data.data
          if(resData.info === 'OK' && resData.city.length > 0){
            let params = {}
            if(String(resData.province) === String(resData.city)){
              params.area = resData.city
            } else {
              params.area = resData.province + '-' + resData.city
            }
            params.ip = res.data.data
            createUserStas(params)
          }
        })
      })
    },
    initOpenId(){
      if(isWeiXin()){
          if(!window.location.href.includes('code=')){
            getBaseInfos('/category')
          } else {
            getopenIdByCode()
          }
      }
    },
    wxShare(){
        // let url = seo.config.wxConfig.categoryPage.link + this.$route.fullPath + '?share=wx'
        let url = seo.config.wxConfig.categoryPage.link + this.$route.fullPath
        let title = seo.config.wxConfig.categoryPage.title
        wxSdk({ url:url }).then(res=>{
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: seo.config.wxConfig.appId, // 必填，公众号的唯一标识
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.data.signature,// 必填，签名
            jsApiList: ['checkJsApi', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage','onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表
          });
          wx.ready(function () {
            wx.checkJsApi({
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage','onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone'], // 必填，需要使用的JS接口列表
                success: function(res) {
                // “分享给朋友”及“分享到QQ”
                if (res.checkResult.updateAppMessageShareData || res.checkResult.onMenuShareAppMessage) {
                    wx.updateAppMessageShareData({ 
                      title: title, // 分享标题
                      desc: seo.config.wxConfig.categoryPage.desc, // 分享描述
                      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                      imgUrl: seo.config.wxConfig.categoryPage.imgUrl, // 分享图标
                      success: function () {
                          // 设置成功
                      }
                    })
                }
                // “分享到朋友圈”及“分享到 QQ 空间”
                if(res.checkResult.updateTimelineShareData || res.checkResult.onMenuShareTimeline){
                    wx.updateTimelineShareData({ 
                      title: title, // 分享标题
                      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                      imgUrl: seo.config.wxConfig.categoryPage.imgUrl, // 分享图标
                      success: function () {
                          // 设置成功
                      }
                    })
                }
            }})
          })
        })
    },
  },
}
</script>

<style scoped lang="scss">
.category-box {
    background: #f3f3f3;
    .search {
      position: fixed;
      max-width: 750px;
      z-index: 1;
      top: 0;
      left: 0;
      right: 0;
      background: #f3f3f3;
      display: flex;
      align-items: center;
      margin: 0 auto;
      .fake-input {
        width: calc(100% - 26px);
        border: 1px solid #eee;
        box-sizing: border-box;
        margin: 10px 5px 10px 10px;
        border-radius: 20px;
        height: 40px;
        line-height: 40px;
        display: flex;
        align-items: center;
        padding-left: 40px;
        color: #78788e;
        background: #fff;
      }
      .searchImg {
        position: absolute;
        left: 25px;
        top: 21px;
      }
    }
    .first-category-row {
      position: fixed;
      max-width: 750px;
      margin: 0 auto;
      left: 0;
      right: 0;
      top: 60px;
      background: #f3f3f3;
      .first-category {
        margin: 0px 10px 0;
        display: flex;
        align-items: center;
        height: 80px;
        overflow-x: scroll;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 10+, edge */
        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
        .first-category-item {
          margin: 0 5px 0;
          .img-active {
            border: 3px solid #ffe8c0;
            // border: 3px solid #ffe8c0; //备选
            // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
            color: #2c3e50;
          }
          .img {
            border: 3px solid rgba(0,0,0,0);
          }
          img {
            border-radius: 10px;
          }
          .label-active {
            font-weight: 600;
            font-size: 12px;
            display: flex;
            color: #2c3e50;
            // background: red;
            // padding: 2px 5px;
            // border-radius: 10px;
            justify-content: center;
            min-width: 50px;
          }
          .label {
            font-size: 12px;
            display: flex;
            // background: red;
            // padding: 2px 5px;
            // border-radius: 10px;
            justify-content: center;
            min-width: 50px;
          }
        }
      }
    }
    .sidebar {
      position: fixed;
      top: 140px;
      width: 120px;
      overflow: scroll;
      background: rgb(243, 243, 243);
      bottom: calc(55px + constant(safe-area-inset-bottom));
      bottom: calc(55px + env(safe-area-inset-bottom));
    }
    .category-card {
      position: fixed;
      z-index: -1;
      max-width: calc(750px - 120px);
      width: calc(100% - 120px);
      margin: 0 auto;
      padding-left: 120px;
      top: 140px;
      bottom: calc(55px + constant(safe-area-inset-bottom));
      bottom: calc(55px + env(safe-area-inset-bottom));
    }
}
</style>